import { defineComponent, nextTick } from "vue";
import axios from 'axios'

import { store } from '#stores/oneform.js'
import AuthorizationDisclosureFormVue from "#components/AuthorizationDisclosureForm/AuthorizationDisclosureForm.vue";
import PatientInfoFormVue from "#components/PatientInfoForm/PatientInfoForm.vue";
import CancellationPolicyFormVue from "#components/CancellationPolicyForm/CancellationPolicyForm.vue";
import FinancialPolicyFormVue from "#components/FinancialPolicyForm/FinancialPolicyForm.vue";
import { VForm } from "vuetify/components";

import Form from '../form.js'

export default defineComponent({
    mixins: [ Form ],
    components: {
        'authorization-disclosure-form': AuthorizationDisclosureFormVue,
        'patient-form': PatientInfoFormVue,
        'cancellation-policy-form': CancellationPolicyFormVue,
        'financial-policy-form': FinancialPolicyFormVue
    },
    data() {
        return {
            store,
            error: null,
            loading: false,
            valid: true
        }
    },
    methods: {
        async submitHook(fd:FormData) {
            if (store.patientForm.medicationListUploadType == 'file' && store.patientForm.medicationListFile)
                fd.append('file', store.patientForm.medicationListFile);
        }
    }
})
